import clsx from 'clsx'
import { DateRangeSchema } from 'cms/schemaTypes/generalSchemas/dateRange'
import { TextItemSchema } from 'cms/schemaTypes/staticPages/objects/textItem'

import CustomPortableText from 'lib/sanity/richText/CustomPortableText'
import { formatDateRange } from 'shared/utils/date'

import styles from './InfoFrame.module.scss'

interface InfoFrameProps extends React.HTMLAttributes<HTMLDivElement> {
  range: DateRangeSchema
  frame1Text: TextItemSchema
}

const InfoFrame = ({ range, frame1Text, className, ...props }: InfoFrameProps) => {
  const rangeText = formatDateRange(range.from || '', range.to || '')

  return (
    <div {...props} className={clsx(styles.infoWrapper, className)}>
      <div className={styles.infoItemWithTagItemWrapper}>
        <div className={styles.infoTag}>
          <strong>{`Program nagród trwa w dniach ${rangeText} r.`}</strong>
        </div>
        <div className={styles.infoItemWithTag}>
          <CustomPortableText value={frame1Text.textField} />
        </div>
      </div>
    </div>
  )
}

export default InfoFrame
